export const AddToCartSucess = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 23 23"
        >
            <g
                id="Group_715"
                data-name="Group 715"
                transform="translate(-0.089)"
            >
                <g
                    id="Ellipse_68"
                    data-name="Ellipse 68"
                    transform="translate(0.089)"
                    fill="#50c0a8"
                    stroke="#99e2d2"
                    strokeWidth="1.5"
                >
                    <circle cx="11.5" cy="11.5" r="11.5" stroke="none" />
                    <circle cx="11.5" cy="11.5" r="10.75" fill="none" />
                </g>
                <g
                    id="Group_519"
                    data-name="Group 519"
                    transform="translate(7.881 8)"
                >
                    <path
                        id="Path_663"
                        data-name="Path 663"
                        d="M8.631.75,3,7.318.75,4.691"
                        transform="translate(-0.75 -0.75)"
                        fill="none"
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                </g>
            </g>
        </svg>
    )
}
